let _initProto, _initClass, _init_formProvider, _init_extra_formProvider, _init_submitEvent, _init_extra_submitEvent, _init_invalidEvent, _init_extra_invalidEvent, _init_defaultValues, _init_extra_defaultValues, _init_defaultValuesData, _init_extra_defaultValuesData, _init_resolver, _init_extra_resolver, _init_mode, _init_extra_mode, _init_reValidateMode, _init_extra_reValidateMode, _init_action, _init_extra_action, _init_method, _init_extra_method;
function _applyDecs(e, t, n, r, o, i) { var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length; function g(t, n, r) { return function (o, i) { n && (i = o, o = e); for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []); return r ? i : o; }; } function b(e, t, n, r) { if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined")); return e; } function applyDec(e, t, n, r, o, i, u, s, f, l, p) { function d(e) { if (!p(e)) throw new TypeError("Attempted to access private element on non-instance"); } var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o; function I(t, n, r) { return function (o, i) { return n && (i = o, o = e), r && r(o), P[t].call(o, i); }; } if (!w) { var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value"; if (f ? (l || D ? P = { get: _setFunctionName(function () { return v(this); }, r, "get"), set: function (e) { t[4](this, e); } } : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) { if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet"); y[+s][r] = o < 3 ? 1 : o; } } for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) { var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = { kind: ["field", "accessor", "method", "getter", "setter", "class"][o], name: r, metadata: a, addInitializer: function (e, t) { if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished"); b(t, "An initializer", "be", !0), i.push(t); }.bind(null, A) }; if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function (e) { return r in e; } }, j || (c.get = f ? E ? function (e) { return d(e), P.value; } : I("get", 0, d) : function (e) { return e[r]; }), E || S || (c.set = f ? I("set", 0, d) : function (e, t) { e[r] = t; }), N = T.call(z, D ? { get: P.get, set: P.set } : P[F], H), A.v = 1, D) { if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined"); } else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N); } return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N; } function w(e) { return m(e, d, { configurable: !0, enumerable: !0, value: a }); } return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function (e) { e && f.push(g(e)); }, p = function (t, r) { for (var i = 0; i < n.length; i++) { var a = n[i], c = a[1], l = 7 & c; if ((8 & c) == t && !l == r) { var p = a[2], d = !!a[3], m = 16 & c; applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function (t) { return _checkInRHS(t) === e; } : o); } } }, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), { e: c, get c() { var n = []; return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)]; } }; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _setFunctionName(e, t, n) { "symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : ""); try { Object.defineProperty(e, "name", { configurable: !0, value: n ? n + " " + t : t }); } catch (e) {} return e; }
function _checkInRHS(e) { if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null")); return e; }
import { RadiantElement, customElement, event, onEvent, onUpdated, prop } from "@ecopages/radiant";
import { provideContext } from "@ecopages/radiant/context";
import { formContext } from "./form-context";
import { FormStore } from "./form-store";
import { RUI_FORM_DEFAULT_VALUES_ATTR } from "./control-protocol";
const noopUnregister = () => {};
const initialFormActions = {
  register: () => noopUnregister,
  updateFieldOptions: () => {},
  handleFieldChange: () => {},
  handleFieldBlur: () => {},
  subscribePresentation: () => noopUnregister
};
let _RuiForm;
class RuiForm extends RadiantElement {
  static {
    ({
      e: [_init_formProvider, _init_extra_formProvider, _init_submitEvent, _init_extra_submitEvent, _init_invalidEvent, _init_extra_invalidEvent, _init_defaultValues, _init_extra_defaultValues, _init_defaultValuesData, _init_extra_defaultValuesData, _init_resolver, _init_extra_resolver, _init_mode, _init_extra_mode, _init_reValidateMode, _init_extra_reValidateMode, _init_action, _init_extra_action, _init_method, _init_extra_method, _initProto],
      c: [_RuiForm, _initClass]
    } = _applyDecs(this, [customElement("rui-form")], [[provideContext({
      context: formContext,
      initialValue: {
        ready: false,
        revision: 0,
        fields: {},
        errors: {},
        actions: initialFormActions
      }
    }), 0, "formProvider"], [event({
      name: "rui-submit",
      bubbles: true,
      composed: true
    }), 0, "submitEvent"], [event({
      name: "rui-invalid",
      bubbles: true,
      composed: true
    }), 0, "invalidEvent"], [prop({
      type: Object,
      defaultValue: {}
    }), 0, "defaultValues"], [prop({
      type: String,
      attribute: RUI_FORM_DEFAULT_VALUES_ATTR
    }), 0, "defaultValuesData"], [prop({
      type: Object
    }), 0, "resolver"], [prop({
      type: String,
      reflect: true,
      defaultValue: "onSubmit"
    }), 0, "mode"], [prop({
      type: String,
      reflect: true,
      attribute: "revalidate-mode",
      defaultValue: "onChange"
    }), 0, "reValidateMode"], [prop({
      type: String,
      reflect: true
    }), 0, "action"], [prop({
      type: String,
      reflect: true
    }), 0, "method"], [onUpdated(["defaultValues", "defaultValuesData", "mode", "reValidateMode"]), 2, "syncOptions"], [onUpdated(["resolver"]), 2, "syncResolver"], [onEvent({
      selector: "button[type=submit]",
      type: "click"
    }), 2, "onSubmitButtonClick"], [onEvent({
      ref: "form",
      type: "submit"
    }), 2, "onNativeSubmit"], [onEvent({
      ref: "form",
      type: "reset"
    }), 2, "onNativeReset"]], 0, void 0, RadiantElement));
  }
  formProvider = (_initProto(this), _init_formProvider(this));
  submitEvent = (_init_extra_formProvider(this), _init_submitEvent(this));
  invalidEvent = (_init_extra_submitEvent(this), _init_invalidEvent(this));
  defaultValues = (_init_extra_invalidEvent(this), _init_defaultValues(this));
  defaultValuesData = (_init_extra_defaultValues(this), _init_defaultValuesData(this));
  resolver = (_init_extra_defaultValuesData(this), _init_resolver(this));
  mode = (_init_extra_resolver(this), _init_mode(this));
  reValidateMode = (_init_extra_mode(this), _init_reValidateMode(this));
  action = (_init_extra_reValidateMode(this), _init_action(this));
  method = (_init_extra_action(this), _init_method(this));
  onSubmit = void _init_extra_method(this);
  store;
  unsubscribeStore;
  nativeFormId = `rui-form-native-${Math.random().toString(36).slice(2, 9)}`;
  lastPublishedRevision = -1;
  lastPublishedContext;
  presentationListeners = /* @__PURE__ */new Set();
  formActions = {
    register: registration => {
      const store = this.ensureStore();
      const unregister = store.register(registration);
      this.publishFormContext({
        force: true
      });
      return () => {
        unregister();
        this.publishFormContext({
          force: true
        });
      };
    },
    updateFieldOptions: (name, options) => {
      this.ensureStore().updateFieldOptions(name, options);
    },
    handleFieldChange: name => {
      void this.ensureStore().handleFieldChange(name).then(() => this.publishFormContext({
        force: true
      }));
    },
    handleFieldBlur: name => {
      void this.ensureStore().handleFieldBlur(name).then(() => this.publishFormContext({
        force: true
      }));
    },
    subscribePresentation: listener => {
      this.presentationListeners.add(listener);
      if (this.lastPublishedContext) {
        listener(this.lastPublishedContext);
      }
      return () => this.presentationListeners.delete(listener);
    }
  };
  connectedCallback() {
    super.connectedCallback();
    this.ensureStore();
    this.publishFormContext({
      force: true
    });
  }
  onConnected() {
    this.wireOrphanSubmitButtons();
  }
  queryNativeForm() {
    return this.getRef("form") ?? this.querySelector("form.rui-form");
  }
  /** Link submit buttons left on the host outside the composed native `<form>`. */
  wireOrphanSubmitButtons() {
    const formEl = this.queryNativeForm();
    if (!formEl) {
      return;
    }
    if (!formEl.id) {
      formEl.id = this.nativeFormId;
    }
    for (const btn of this.querySelectorAll("button[type=submit]")) {
      if (formEl.contains(btn)) {
        continue;
      }
      btn.setAttribute("form", formEl.id);
    }
  }
  runFormSubmit() {
    const store = this.ensureStore();
    void store.handleSubmit(async values => {
      this.submitEvent.emit({
        values
      });
      if (typeof this.onSubmit === "function") {
        await this.onSubmit(values);
        return;
      }
      if (this.hasNativeSubmission()) {
        this.queryNativeForm()?.submit();
      }
    }, errors => {
      this.invalidEvent.emit({
        errors
      });
    });
  }
  hasNativeSubmission() {
    return typeof this.onSubmit !== "function" && (this.getAttribute("action") !== null || this.getAttribute("method") !== null);
  }
  disconnectedCallback() {
    this.unsubscribeStore?.();
    this.unsubscribeStore = void 0;
    super.disconnectedCallback();
  }
  resolveMode() {
    const fromAttr = this.getAttribute("mode");
    if (fromAttr) {
      return fromAttr;
    }
    return this.mode ?? "onSubmit";
  }
  resolveReValidateMode() {
    const fromAttr = this.getAttribute("revalidate-mode");
    if (fromAttr) {
      return fromAttr;
    }
    return this.reValidateMode ?? "onChange";
  }
  resolveDefaultValues() {
    if (this.defaultValues && Object.keys(this.defaultValues).length > 0) {
      return this.defaultValues;
    }
    const raw = this.defaultValuesData ?? this.getAttribute(RUI_FORM_DEFAULT_VALUES_ATTR);
    if (!raw) {
      return this.defaultValues ?? {};
    }
    try {
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
    } catch {
      return this.defaultValues ?? {};
    }
  }
  ensureStore() {
    if (this.store) {
      return this.store;
    }
    this.store = new FormStore({
      defaultValues: this.resolveDefaultValues(),
      resolver: typeof this.resolver === "function" ? this.resolver : void 0,
      mode: this.resolveMode(),
      reValidateMode: this.resolveReValidateMode()
    });
    this.unsubscribeStore = this.store.subscribe(() => this.publishFormContext());
    return this.store;
  }
  buildFieldPresentations(store) {
    const fields = {};
    for (const name of store.getRegisteredFieldNames()) {
      const message = store.getFieldError(name);
      const show = store.shouldDisplayFieldError(name);
      fields[name] = {
        error: show ? message : void 0,
        invalid: Boolean(show && message)
      };
    }
    return fields;
  }
  publishFormContext(options) {
    const store = this.store;
    if (!store) {
      return;
    }
    const revision = store.getRevision();
    if (!options?.force && revision === this.lastPublishedRevision) {
      return;
    }
    this.lastPublishedRevision = revision;
    const nextContext = {
      ready: true,
      revision,
      fields: this.buildFieldPresentations(store),
      errors: {
        ...store.errors
      },
      actions: this.formActions
    };
    this.lastPublishedContext = nextContext;
    this.formProvider.setContext(nextContext);
    for (const listener of this.presentationListeners) {
      listener(nextContext);
    }
  }
  syncOptions() {
    const store = this.ensureStore();
    store.updateOptions({
      defaultValues: this.resolveDefaultValues(),
      mode: this.resolveMode(),
      reValidateMode: this.resolveReValidateMode()
    });
  }
  syncResolver() {
    if (typeof this.resolver === "function") {
      this.ensureStore().updateOptions({
        resolver: this.resolver
      });
    }
  }
  onSubmitButtonClick(event2) {
    event2.preventDefault();
    this.runFormSubmit();
  }
  onNativeSubmit(event2) {
    event2.preventDefault();
    this.runFormSubmit();
  }
  onNativeReset() {
    this.store?.reset();
  }
  static {
    _initClass();
  }
}
export { _RuiForm as RuiForm };